import { render, staticRenderFns } from "./CertificatesConfirmModal.vue?vue&type=template&id=4e6bba3d&scoped=true"
import script from "./CertificatesConfirmModal.vue?vue&type=script&lang=js"
export * from "./CertificatesConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./CertificatesConfirmModal.vue?vue&type=style&index=0&id=4e6bba3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6bba3d",
  null
  
)

export default component.exports